module.exports = __webpack_public_path__ + "media/images/svg/linkedin-75c6a03d4d546b4a87985041ac0d0177.svg";